export default __webpack_public_path__ + "static/media/outside_bets.16e24dc2.mp3";